import React from 'react';
import LensView from './LensView'
import OldValuesHeader from '../../oldValues/OldValuesHeader';

let ContactLensPrescription = props => {
  const { fieldsValues, template, previousExams, fieldKey, overviewName, examId } = props;

  const renderPrescriptions = (values) => (values || []).map((contactLens, index) => (
    <div className="col-12 py-4" key={contactLens.id || index}>
      <div><span>Contact Lens #{index + 1}</span></div>
      <LensView
        fieldsValues={contactLens}
        template={template?.contact_lenses?.[0] || template}
      />
    </div>
  ));

  return (
    <>
      {fieldsValues && <div className="row">{renderPrescriptions(fieldsValues)}</div>}
      {previousExams
        ?.filter(item => item.id !== examId)
        .flatMap(prevExam => {
          const values = prevExam?.[fieldKey] || [];
          return values.map((contactLens, index) => (
            <div className="col-12 border rounded mb-4 px-0" key={`${prevExam.id}-${contactLens.id || index}`}>
              <div className="row mx-0">
                <OldValuesHeader
                  prevExam={prevExam}
                  overviewName={overviewName}
                  examId={examId}
                  importIds={contactLens.id ? [contactLens.id] : []}
                  importSourceLenses={[contactLens]}
                />
                <div className="col-12 py-4">
                  <div><span>Contact Lens #{index + 1}</span></div>
                  <LensView
                    fieldsValues={contactLens}
                    template={template?.contact_lenses?.[0] || template}
                  />
                </div>
              </div>
            </div>
          ));
        })}
    </>
  )
}


export default ContactLensPrescription;
